import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from "axios";
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
// import "amfe-flexible/index"
// eslint-disable-next-line no-unused-vars
// import Service from '@vue/cli-service'
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.use(ElementUI);
// axios.defaults.baseURL = 'http://localhost:8017';
axios.defaults.baseURL = 'http://49.212.160.220:7350';
axios.defaults.timeout = 5000;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

